import { render } from "./TheEmptyHeader.vue?vue&type=template&id=360e6a4e&scoped=true"
import script from "./TheEmptyHeader.vue?vue&type=script&lang=js"
export * from "./TheEmptyHeader.vue?vue&type=script&lang=js"

import "./TheEmptyHeader.vue?vue&type=style&index=0&id=360e6a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360e6a4e"]])

export default __exports__